/**
 * Analytics event name constants for PostHog tracking.
 *
 * Naming convention: SCREAMING_SNAKE_CASE for constants, snake_case for event string values.
 */

// Authentication & Sessions
export const USER_LOGGED_IN = 'user_logged_in'
export const USER_LOGGED_OUT = 'user_logged_out'
export const PASSWORD_RESET_REQUESTED = 'password_reset_requested'

// View Preferences
export const VIEW_MODE_CHANGED = 'view_mode_changed'
export const VIEW_MODE_ACTIVE = 'view_mode_active'

// Repair Order Workflow (frontend)
export const RO_DRAGGED = 'ro_dragged'

// Collaboration
export const COMMENT_SENT = 'comment_sent'
export const COMMENTS_READ = 'comments_read'
export const CHAT_OPENED = 'chat_opened'

// Search, Filter, Sort
export const SEARCH_PERFORMED = 'search_performed'
export const FILTER_APPLIED = 'filter_applied'
export const FILTER_CLEARED = 'filter_cleared'
export const SORT_CHANGED = 'sort_changed'

// Exports
export const EXPORT_INITIATED = 'export_initiated'

// Notifications
export const NOTIFICATION_MENU_OPENED = 'notification_menu_opened'
export const NOTIFICATION_CLICKED = 'notification_clicked'
